module.exports = __webpack_public_path__ + "static/media/jhonobando.86253893.png";